import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum ESetIsB2BModeEnabledActionType {
  Set = 'user/setIsB2BModeEnabled/set',
}

export type TIsB2BModeEnabled = ITypedReduxAction<ESetIsB2BModeEnabledActionType.Set, boolean>;
